import React from "react";
import { Row, Col, Form, Select, Button, Typography, theme } from "antd";
import { SafetyCertificateOutlined, ReloadOutlined } from "@ant-design/icons";

const { Text } = Typography;

interface UserRoleFormSectionProps {
  canChangeRole: boolean;
  roleOptionsList: any[];
  resettingPassword: boolean;
  onResetPassword: () => void;
}

export const UserRoleFormSection: React.FC<UserRoleFormSectionProps> = ({
  canChangeRole,
  roleOptionsList,
  resettingPassword,
  onResetPassword,
}) => {
  const { token } = theme.useToken();

  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
        <SafetyCertificateOutlined style={{ color: token.colorPrimary, fontSize: 14 }} />
        <Text strong style={{ fontSize: 12, color: token.colorTextHeading, textTransform: "uppercase", letterSpacing: "0.05em" }}>
          Role & Authorization
        </Text>
      </div>

      <Row gutter={[12, 14]}>
        <Col span={24}>
          <Form.Item
            label="Assigned System Role"
            name="role"
            style={{ marginBottom: 0 }}
            rules={[{ required: true, message: "Please select a system role" }]}
            help={
              <span style={{ fontSize: 11.5, color: token.colorTextDescription, marginTop: 4, display: "block" }}>
                {canChangeRole
                  ? "Select the system role to assign permission scopes across the portal."
                  : "Only Super Admin and Support Admin users can change user roles."}
              </span>
            }
          >
            <Select
              disabled={!canChangeRole}
              placeholder="Select role"
              options={roleOptionsList}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>

      <div
        style={{
          marginTop: 16,
          padding: "12px 14px",
          background: token.colorFillAlter,
          borderRadius: 6,
          border: `1px solid ${token.colorBorderSecondary}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <div>
          <Text strong style={{ fontSize: 12.5, display: "block", color: token.colorTextHeading }}>
            Password Reset
          </Text>
          <Text style={{ fontSize: 11.5, color: token.colorTextDescription, display: "block" }}>
            Generate a new random password for this user account.
          </Text>
        </div>
        <Button
          size="small"
          icon={<ReloadOutlined spin={resettingPassword} />}
          loading={resettingPassword}
          onClick={onResetPassword}
          style={{ borderColor: token.colorWarning, color: token.colorWarning, fontWeight: 500 }}
        >
          Reset Password
        </Button>
      </div>
    </div>
  );
};
